"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemoryGameType = void 0;
const getMemoryGameType = (mode, reverse, gridSize) => {
    let memoryGameType;
    if (mode === 'input') {
        memoryGameType = reverse ? 'backward' : 'forward';
    }
    else {
        memoryGameType = reverse ? 'backward-training' : 'forward-training';
    }
    memoryGameType += '-' + gridSize;
    return memoryGameType;
};
exports.getMemoryGameType = getMemoryGameType;
